export default __webpack_public_path__ + "static/media/googleAssistant.547075a7.jpg";